import { render, staticRenderFns } from "./SoccerScoresConditions.vue?vue&type=template&id=9d50fa70&"
import script from "./SoccerScoresConditions.vue?vue&type=script&lang=js&"
export * from "./SoccerScoresConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports